import { render, staticRenderFns } from "./motivoDeclinacionEdit.vue?vue&type=template&id=606b987a&"
import script from "./motivoDeclinacionEdit.vue?vue&type=script&lang=js&"
export * from "./motivoDeclinacionEdit.vue?vue&type=script&lang=js&"
import style0 from "./motivoDeclinacionEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports